<template>
  <li class="relative"
    v-outside-click="{
      'exclude': [],
      'handler': 'onLoseFocus'
    }">
    <button
      class="flex self-center justify-between w-full py-2 pl-3 pr-4 text-gray-400 border-b border-gray-100 bg-gray-200 md:bg-transparent hover:bg-gray-50 md:hover:bg-transparent md:border-0 md:hover:text-gray-200 md:p-0 md:w-auto"
      aria-current="page"
      :disabled="disabled"
      @click="onMenuClick">
      {{ title }}
      <svg class="w-5 h-5 ml-1" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"></path>
      </svg>
    </button>
    <!-- Dropdown menu -->
    <div
      id="dropdownNavbar"
      class="absolute right-4 z-50 text-left font-normal bg-white divide-y divide-gray-100 rounded-lg shadow w-48"
      :class="{
        'hidden': hideMenu
      }">
      <ul class="py-2 text-sm text-gray-700"
        aria-labelledby="dropdownLargeButton">
        <slot name="menuItems"></slot>
      </ul>
    </div>
  </li>
</template>

<script>
export default {
  components: {},
  props: {
    title: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hideMenu: true,
    }
  },
  methods: {
    closeMenu() {
      this.hideMenu = true
    },
    openMenu() {
      this.hideMenu = false
    },
    onMenuClick() {
      this.hideMenu = !this.hideMenu
    },
    onLoseFocus() {
      this.closeMenu()
    }
  }
}
</script>
